import axios from 'axios';
import { UserInfo } from 'types/UserInfo';

export interface OpenDepositRequestRow {
  id: number;
  code: string;
  amount: number;
  status: string;
  created_at: string;
}

interface OpenDepositRequestsResponse {
  rows: OpenDepositRequestRow[];
  count: number;
}

export async function createDepositRequest(
  user: UserInfo,
  amount: number
): Promise<OpenDepositRequestRow | null> {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';
  try {
    const { data } = await axios.post<OpenDepositRequestRow>(
      `${baseUrl}/create_deposit_request`,
      {
        player_id: user.id,
        amount,
      }
    );
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export async function getOpenDepositRequests(
  user: UserInfo
): Promise<OpenDepositRequestRow[]> {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';
  try {
    const { data } = await axios.get<OpenDepositRequestsResponse>(
      `${baseUrl}/get_open_deposit_requests?player_id=${user.id}`
    );
    return data.rows ?? [];
  } catch (e) {
    console.error(e);
    return [];
  }
}
